import { Component, effect, Input,} from "@angular/core";
import { Menu } from "../menu/menu.model";
import { MenuService } from "../../services/menu.service";
import { RouterModule } from "@angular/router";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { Router } from "@angular/router";
import { BreakPointService } from "../../../shared/services/break-point/break-point.service";

@Component({
  selector: "app-vertical-menu",
  imports: [
    RouterModule,
    MatTooltipModule,
    MatIconModule,
    CommonModule,
    MatListModule,
    MatMenuModule,
  ],
  templateUrl: "./vertical-menu.component.html",
  styleUrl: "./vertical-menu.component.scss",
})
export class VerticalMenuComponent {
  @Input("menuItems") menuItems: Menu[] | undefined;
  @Input("menuParentId") menuParentId: number | undefined;
  parentMenu: Array<Menu> | undefined;
  menuCollapsed: boolean = true;
  isMobile = false;
  constructor(public menuService: MenuService, public router: Router, public breakPointService: BreakPointService) {
    effect(() => {
      this.menuCollapsed = this.menuService.isMenuCollapsed();
    });
    effect(() => {
      const bp = this.breakPointService.breakPointSignal();
      this.isMobile = bp === 'sm' || bp === 'xs';
    });
  }

  // activeSubMenu: Menu[] = [];

  ngOnInit() {
    this.parentMenu = this.menuItems?.filter(
      (item) => item.parentId == this.menuParentId
    );
  }

  /**
   * Submenus for a parent menu id (role-filtered list comes from parent via `menuItems`).
   */
  subMenu(id: number): Menu[] {
    return this.menuItems?.filter((m) => m.parentId === id) ?? [];
  }

  /**
   * Top-level menus (`parentId === 0`).
   */
  menuList(id: number): Menu[] {
    return this.menuItems?.filter((m) => m.parentId === id) ?? [];
  }
  
  // Handle menu item click event
  onClickMenu(menuId: number) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems ?? [], menuId);
  }
  // Handle menu click event
  // If the menu has a sub-menu, open it; otherwise, navigate to the menu's route
  handleMenuClick(menu: Menu): void {
    if (menu.hasSubMenu) {
      menu.subMenu = !menu.subMenu;
    } else {
      this.onClickMenu(menu.id);
      if (this.isMobile) {
        this.menuService.closeDrawer();
      }
    }
  }

  // Check if the menu is active based on the router link
  isParentActive(menu: Menu): boolean {
    const children = this.subMenu(menu.id) || [];
    return children.some(
      (child) =>
        !!child.routerLink && this.router.url.includes(child.routerLink)
    );
  }

  onSubMenuClick() {
    if (this.isMobile) {
      this.menuService.closeDrawer();
    }
  }
}
